import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function AboutHero() {
  const { t } = useTranslation('about');

  return (
    <section className="relative min-h-[400px] md:min-h-[480px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=warm%20ambient%20lighting%20of%20a%20live%20jazz%20concert%20stage%20in%20a%20vintage%20venue%20with%20golden%20spotlights%20and%20elegant%20atmosphere%2C%20professional%20concert%20photography%2C%20amber%20and%20gold%20tones%2C%20blurred%20bokeh%20background%20with%20warm%20lighting&width=1600&height=600&seq=about-hero&orientation=landscape"
          alt="Live music"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60" />
      </div>
      <div className="relative z-10 text-center px-6 max-w-3xl">
        <span className="inline-block text-xs md:text-sm font-semibold text-amber-400 uppercase tracking-widest mb-4">
          {t('heroLabel')}
        </span>
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6">
          {t('heroTitleLine1')}
          <br />
          {t('heroTitleLine2')}
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto leading-relaxed">
          {t('heroDescription')}
        </p>
      </div>
    </section>
  );
}